import { DateTime } from 'luxon'

import ServerStore from '../Stores/ServerStore'

export default function setServerStore (status='pending')
{
	ServerStore.update(function (store)
	{
		store.status = status;

		store.date = DateTime.now().toISO();
	});
}